import { useMemo } from 'react';
import PageBanner from '../components/ui/PageBanner';
import { getJobById } from '../data/careers';
import './Branches.css';

export default function CareerDetails({ setPage, route }) {
  const jobId = route?.params?.jobId;
  const job = useMemo(() => getJobById(jobId), [jobId]);

  return (
    <>
      <PageBanner title={job.title} crumbs={['Home', 'Careers', job.title]} />

      <section className="section">
        <div className="section-inner">
          <div className="career__detail card">
            <div className="career__detail-head">
              <h3 className="career__detail-title">{job.title}</h3>
              <div className="career__detail-meta">
                <span>{job.department}</span>
                <span>•</span>
                <span>{job.location}</span>
                <span>•</span>
                <span>{job.type}</span>
              </div>
            </div>

            <p className="section-text">{job.overview}</p>

            <div className="career__detail-box">
              <div>
                <strong>Department</strong>
                <span>{job.department}</span>
              </div>
              <div>
                <strong>Location</strong>
                <span>{job.location}</span>
              </div>
              <div>
                <strong>Employment</strong>
                <span>{job.type}</span>
              </div>
            </div>

            <h4 className="career__section-title">Key Responsibilities</h4>
            <ul className="career__bullets">
              {job.responsibilities.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            <h4 className="career__section-title">Education &amp; Experience</h4>
            <ul className="career__bullets">
              {job.education.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            {job.skills ? (
              <>
                <h4 className="career__section-title">Skills Required</h4>
                <ul className="career__bullets">
                  {job.skills.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </>
            ) : null}

            {job.traits ? (
              <>
                <h4 className="career__section-title">Personality &amp; Professional Traits</h4>
                <ul className="career__bullets">
                  {job.traits.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </>
            ) : null}

            <h4 className="career__section-title">Key Performance Indicators (KPIs)</h4>
            <ul className="career__bullets">
              {job.kpis.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            <div className="career__actions">
              <button type="button" className="btn-outline" onClick={() => setPage('branches')}>
                Back to Careers
              </button>
              <button
                type="button"
                className="btn-primary"
                onClick={() => setPage('career-apply', { params: { jobId: job.id } })}
                style={{ marginLeft: 10 }}
              >
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

